import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
const FooterCard = styled.div `
  position: fixed;
  right: 1.65vw;
  bottom: 1.35vw;
  width: clamp(9.2rem, 9.8vw, 10.2rem);
  min-height: clamp(3.35rem, 3.6vw, 3.7rem);
  padding: clamp(0.56rem, 0.64vw, 0.62rem) clamp(0.68rem, 0.76vw, 0.74rem);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: clamp(0.9rem, 0.95vw, 0.95rem);
  background: linear-gradient(180deg, #1f2934 0%, #1a222d 100%);
  box-shadow:
    inset 0 1px 0 rgba(112, 129, 151, 0.22),
    0 14px 28px rgba(0, 0, 0, 0.25);
  z-index: 2;

  @media (max-width: 768px) {
    right: 1rem;
    bottom: 1rem;
    width: clamp(9.3rem, 40vw, 10.6rem);
    min-height: 3.4rem;
  }
`;
const Content = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
`;
const BrandLockup = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;
const Logo = styled.img `
  width: clamp(5.5rem, 6vw, 6.15rem);
  height: auto;
  display: block;
`;
const AppText = styled.div `
  margin-top: clamp(0.08rem, 0.12vw, 0.12rem);
  margin-left: clamp(2.35rem, 2.55vw, 2.6rem);
  color: #00bceb;
  font-family: 'Sora', sans-serif;
  font-size: clamp(0.48rem, 0.52vw, 0.52rem);
  font-weight: 500;
  line-height: 1.1;
  white-space: nowrap;
`;
const LegacyFooterBrand = () => {
    return (_jsx(FooterCard, { children: _jsx(Content, { children: _jsxs(BrandLockup, { children: [_jsx(Logo, { src: require('../../../../../assets/images/cisco_spaces_logo.png'), alt: "Cisco Spaces" }), _jsx(AppText, { children: "ciscospaces.app" })] }) }) }));
};
export default LegacyFooterBrand;
